import { render, staticRenderFns } from "./NavigationItemBadge.vue?vue&type=template&id=f16341ca&"
import script from "./NavigationItemBadge.vue?vue&type=script&lang=js&"
export * from "./NavigationItemBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports